<style type="text/css">
.chartjs-render-monitor{
	height:340px !important;
}
</style>

<template>
	<div>
		<!--  -->
		<div>
			<status-stats :status_counts="status_counts"/>
		</div>
		<!--  -->
		<v-row>
			<v-col cols="12" md="7" class="py-0">
				<v-row class="custome-form py-0">
					<v-col cols="6" md="8" class="pb-0">
						<p class="sub-title-text">{{$lang.SHIPMENTS}}</p>
					</v-col>
					<v-col cols="6" md="4" class="pb-0">
						<v-select
						v-model="graph_filter"
						:items="graph_filter_option" 
						item-text="text"
						item-value="value"
						@change="getOverviewData"
						dense
						outlined
						class="secondary-text"
						hide-details
						></v-select>
					</v-col>
				</v-row>
				<!--  over view chart -->
				<shipment-graph ref="overview_graph" :graph_label="graph_label" :graph_value="graph_value" />

			</v-col>
			<!--Live agent section  -->
			<v-col cols="12" md="5">
				<live-agents :agent_list="agent_list" :status_counts="status_counts"/>
			</v-col>
		</v-row>

		<account-block-dialog :is_bloked="is_bloked"/>

	</div>
</template>
<script type="text/javascript">

export default{
	components: {
		StatusStats: () => import('./child/StatusStats.vue'),
		LiveAgents: () => import('./child/LiveAgents.vue'),
		ShipmentGraph: () => import('./child/ShipmentGraph.vue'),
		AccountBlockDialog :()=>import('@/components/common-components/AccountBlockDialog.vue'),

	},
	data(){
		return{
			graph_filter_option:[{text:'Today',value:"Today"},{text:'This week',value:"Weekly"},{text:'This month',value:"Monthly"},{text:'This Year',value:"Yearly"}],
			graph_filter:null,
			graph_label:[],
			graph_value:[],
			agent_list:[],
			status_counts:{
				status_counts:"",
				total_shipment:"",
				at_warehouse:"",
				out_for_delivery_count:"",
				delivered_count:"",
				new_order_count:"",
				returned_count:"",
				partial_returned_count:"",
				payment_count:"",
			},
			is_bloked:false,
		}
	},
	created(){
		this.$store.dispatch('drawer/setActiveTab',this.$route.name)
		this.getOverviewData();
		this.liveAgentList();
	},
	methods:{
		/* Fetching over view data*/ 
		getOverviewData(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let graph_type=this.graph_filter
			if(!this.graph_filter)
				graph_type=this.graph_filter_option[3].value

			this.graph_filter=graph_type

			let params={
				'graph_type':graph_type
			};

			const successHandler = (response) => {
				if (response.data.success){
					self.status_counts= response.data
					if(self.$store.state.user_type==self.$keys.WAREHOUSE)
						self.is_bloked= !response.data.is_active

					self.graph_label= response.data.graph_label
					self.graph_value= response.data.graph_value
					setTimeout(()=>{
						this.$refs.overview_graph.initChart()
					},500);

				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)

			};
			self.request_GET( self,self.$urls.WAREHOUSE_DASHBOARD,params,successHandler,null,null,finallyHandler)
		},
		/* fetching agent list*/ 
		liveAgentList(){
			const self=this
			this.$store.dispatch('setPageLoader', true)
			self.filter_agent_type=status
			let params={
				page_number:this.page_number,
				page_length:this.$keys.PAGE_LENGTH,
				// filter_agent_type:JSON.stringify([self.$keys.PICKUP_AGENT])
			};

			const successHandler = (response) => {
				self.agent_list=response.data.agent_list

			};
			const finallyHandler = () => {
				self.$store.dispatch('setPageLoader', false)
			};
			self.request_GET( self,self.$urls.AGENT_LIST,params,successHandler,null,null,finallyHandler)

		},
		/* update graph data*/ 
		updateGraph(){
			this.$refs.overview_graph.initChart()

		}
	}

}

</script>